import { TableRow, TableCell } from "@mui/material";

const IncomeTax = () => {
  return (
    <>
      <TableRow>
        <TableCell
          sx={{ bgcolor: "#f01e2c", color: "white", fontWeight: "bold" }}
          className="bg-primary p-0"
        >
          2) INCOME TAX
        </TableCell>
      </TableRow>
      <TableRow className="bg-danger-subtle">
        <TableCell className="p-0 ps-3 ">Filling of Return of Income</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">I) For Individuals/HUFs etc.</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          (a) Filling of Return of Income with Salary/Other Sources/Share of
          Profit
        </TableCell>
        <TableCell className="p-0"></TableCell>
        <TableCell className="p-0" />
        <TableCell className="p-0"></TableCell>
        {Array(5).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          (b) Filling of Return of Income with detailed Capital Gain working
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          i) Less than 10 Transactions (For Shares & Securities)
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          ii) More than 10 Transactions (For Shares & Securities)
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          (c) Filling on Return of Income for Capital Gain on Immovable property
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          (d) Filling on Return of Income with Preparation of Bank Summary,
          Capital A/c & Balance Sheet.
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          II) Partnership Firms/Sole Proprietor with Advisory Services
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(b) Minor’s I.T. Statement</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(c) Private Ltd. Company:</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(i) Active</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">ii) Defunct</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(d) Public Ltd. Company</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">i) Active</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">ii) Defunct</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow className="bg-danger-subtle">
        <TableCell className="p-0 ps-3">Filling of Forms etc.</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          Filling of TDS/TCS Return (per Form)
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">i) With 5 or less Entries</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">ii) With more than 5 entries</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          Filling of Form No. 15-H/G (per Set)
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">Form No. 49-A/49-B</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          Any other Forms filed under the Income Tax Act
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow className="bg-danger-subtle">
        <TableCell className="p-0 ps-3">CERTIFICATE</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          Obtaining Certificate from Income Tax Department
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow className="bg-danger-subtle">
        <TableCell className="p-0 ps-3">Filling of Appeals etc.</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          a) First Appeal Preparation of Statement of Facts, Grounds of Appeal,
          Etc.
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">b) Second Appeal (Tribunal)</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow className="bg-danger-subtle">
        <TableCell className="p-0 ps-3">Assessments etc.</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          a) Attending Scrutiny Assessment/Appeal
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(i) Corporate</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">(ii) Non Corporate</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          b) Attending before Authorities
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">
          c) Attending before Appellate Tribunal
        </TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
      <TableRow>
        <TableCell className="p-0 ps-3">d) Settlement Commission</TableCell>
        {Array(8).fill(<TableCell className="p-0" />)}
      </TableRow>
    </>
  );
};

export default IncomeTax;
